
module.directive('programDescriptionForm', function(ModelService) {
    return {
        restrict: 'E',
        templateUrl: 'programs/basic/programDescriptionForm',
        scope: {description: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.data = ModelService.copyFields(scope.description, [
                'description', 'format']);
            basicForm.data = scope.data;
            scope.form = basicForm.getForm();

            scope.preview = {mode: 'edit'};
            scope.previewOptions = [
                {name: 'Edit', value: 'edit'},
                {name: 'Preview', value: 'preview'},
            ];

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.description, data);
            };
        },
    };
});